export type FoodChannelId = 'grab' | 'gofood' | 'shopeefood'

export type FoodChannel = {
  id: FoodChannelId
  label: string
  url: string
}

export type BrandFoodFields = {
  grabFoodUrl?: string | null
  goFoodUrl?: string | null
  shopeeFoodUrl?: string | null
  hasGrabFood?: boolean
  hasGoFood?: boolean
  hasShopeeFood?: boolean
}

export function normalizePublicUrl(raw?: string | null) {
  if (!raw || typeof raw !== 'string') return null
  const t = raw.trim()
  if (!t) return null
  if (t.startsWith('http://') || t.startsWith('https://')) return t
  return `https://${t}`
}

/** Channel yang punya URL toko — dipakai di landing & keranjang */
export function getFoodChannels(brand: BrandFoodFields): FoodChannel[] {
  const grab = normalizePublicUrl(brand.grabFoodUrl)
  const go = normalizePublicUrl(brand.goFoodUrl)
  const shopee = normalizePublicUrl(brand.shopeeFoodUrl)

  const channels: FoodChannel[] = []
  if (grab) channels.push({ id: 'grab', label: 'GrabFood', url: grab })
  if (go) channels.push({ id: 'gofood', label: 'GoFood', url: go })
  if (shopee) channels.push({ id: 'shopeefood', label: 'ShopeeFood', url: shopee })

  // Fallback lama: checkbox tanpa URL (tidak bisa deep link ke toko)
  if (channels.length === 0) {
    if (brand.hasGrabFood) {
      channels.push({
        id: 'grab',
        label: 'GrabFood',
        url: 'https://food.grab.com/id/id',
      })
    }
    if (brand.hasGoFood) {
      channels.push({ id: 'gofood', label: 'GoFood', url: 'https://gofood.co.id' })
    }
    if (brand.hasShopeeFood) {
      channels.push({
        id: 'shopeefood',
        label: 'ShopeeFood',
        url: 'https://shopeefood.co.id',
      })
    }
  }

  return channels
}

/** Buka link toko di tab baru — di HP biasanya langsung ke app merchant */
export function openFoodStore(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer')
}
